export default __webpack_public_path__ + "static/article-how-to-manage-your-money-digitally-113066f7458201ece43ac7dfe75604b3.jpg";